import messages from './messages.json';

export const getMessages = (key, status) => {
  if (!messages[key][status]) {
    return messages.common['500'];
  }

  return messages[key][status];
};
